import { observer } from 'mobx-react'
import ContentState from '../../../../stores/ContentState'
import TabContent from '../../../common/TabContent'
import './index.scss'

const Product = observer(() => {
  if (!ContentState.about) return <></>
  return (
    <div className="friendly-block__product">
      <div
        className="friendly-block__apps-title"
        dangerouslySetInnerHTML={{
          __html: ContentState.about?.friendly.lead.title,
        }}
      ></div>
      <TabContent
        isActive={true}
        tab={{
          text: ContentState.about.friendly.lead.text,
          src: ContentState.about.friendly.lead.img,
          poster: ContentState.about.friendly.lead.poster,
          video: ContentState.about.friendly.lead.video,
          numbers: [],
        }}
        numbers={false}
      />
    </div>
  )
})

export default Product
